import { CommonResponse, get } from './clientAxios';

export async function fetchComplexPyeongList({
  complexId,
}: {
  complexId: number;
}) {
  try {
    const response = await get<number[]>(`/api/complex/${complexId}/pyeong`);
    const { data } = response;
    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}
